import type { ReactNode } from 'react';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  dateRange?: ReactNode;
  meta?: ReactNode;
}

export function PageHeader({ title, subtitle, actions, dateRange, meta }: PageHeaderProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <div className={styles.titleGroup}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        <div className={styles.right}>
          {dateRange && <div className={styles.dateRange}>{dateRange}</div>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      </div>
      {meta && <div className={styles.meta}>{meta}</div>}
    </div>
  );
}
